(function () {
	var nextslide = function () {
		var heroContainer = document.querySelector(".flex-content.hero .hero_images.scroll");
		if (!heroContainer) return;

		var images = heroContainer.querySelectorAll(".hero_image");
		if (images.length > 1) {
			var curr = heroContainer.querySelector(".hero_image.current") || images[0];
			var currIndex = Array.from(images).indexOf(curr);
			var next = images[currIndex + 1] || images[0];

			curr.classList.add("prev");
			curr.classList.remove("current");
			next.classList.add("current");
			next.classList.remove("prev");

			setTimeout(function () {
				curr.classList.remove("prev");
			}, 2500);
		}
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	function init() {
		var style = document.createElement('style');
		style.innerHTML = 'div.hero_images.scroll div.hero_image.current, div.hero_images.scroll div.hero_image.prev { transform: translate3d(100px, 0, 0) !important; }';
		document.head.appendChild(style);

		setTimeout(function() {
			nextslide();
		}, 2500);
		var intervalId = window.setInterval(function () {
			nextslide();
		}, 5000);
	}
})();
